import { FormControlLabel, FormHelperText, Grid, MenuItem, Switch, TextField } from '@material-ui/core';
import CustomMaskedInput from 'components/MaskedInput';
import React from 'react';
import { Space } from 'v2/components/Shared/Space';
import { EChargeType, EComissionType } from 'v2/interfaces/product';

import type IProduct from 'interfaces/IProduct';

export type Props = {
  loading: boolean;
  product: IProduct;
  handleChange: (name: string, value: any) => void;
  validInput: (field: string) => boolean;
  errorFor: (field: string) => string;
  classes: any;
  isSubscription: boolean;
  userHasSubscriptionModule: boolean;
};

export const Recruitment = ({ product, handleChange, validInput, errorFor, isSubscription }: Props) => {
  const changeSwitchState = (name: string) => (event: React.ChangeEvent<HTMLInputElement>) => handleChange(name, event.target.checked);
  const changeTextValue = (name: string) => (value: number | string) => handleChange(name, value);

  return (
    <>
      <FormControlLabel
        label='Comissão de recrutamento'
        control={<Switch color='primary' checked={product.recruit} onChange={changeSwitchState('recruit')} />}
      />
      <FormHelperText>
        Ex: O Afiliado que indicar outro Afiliado receberá parte das primeiras vendas deste afiliado indicado.{' '}
        <a
          target='_blank'
          rel='noopener noreferrer'
          href='https://ajuda.eduzz.com/hc/pt-br/articles/13004454300443-Como-Convidar-um-Afiliado-Atrav%C3%A9s-da-Ferramenta-de-Recrutamento-'
        >
          Saiba Mais
        </a>
      </FormHelperText>

      {product.recruit && (
        <>
          <Space axis='vertical' size={16} />

          <Grid container justifyContent='space-between' spacing={4}>
            <Grid item xs={12} md={4}>
              <TextField
                id='recruit_commission_type'
                label='Tipo de comissão'
                helperText='Comissão com percentual de ganho bruto.'
                select
                fullWidth
                value={product.recruit_commission_type}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChange('recruit_commission_type', e.target.value)}
                InputProps={{
                  disableUnderline: true,
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                disabled={product.recruit_commission_type === EComissionType.PERCENTAGE}
              >
                <MenuItem value={EComissionType.PERCENTAGE}>Porcentagem</MenuItem>
                {product.recruit_commission_type === EComissionType.VALUE && product.charge_type !== EChargeType.FREE && (
                  <MenuItem value={EComissionType.VALUE} disabled>
                    Valor
                  </MenuItem>
                )}
              </TextField>
            </Grid>

            {product.recruit_commission_type === EComissionType.PERCENTAGE && (
              <Grid item xs={12} md={4}>
                <CustomMaskedInput
                  fullWidth
                  label='Percentual de comissão recorrente'
                  disableUnderline
                  InputLabelProps={{ shrink: true }}
                  mask='percent'
                  startAdornment='%'
                  value={product.recruit_commission_value}
                  onChange={changeTextValue('recruit_commission_value')}
                  helperText={validInput('recruit_commission_value') ? errorFor('recruit_commission_value') : ''}
                  error={validInput('recruit_commission_value')}
                />
              </Grid>
            )}
            {product.recruit_commission_type === EComissionType.VALUE && (
              <Grid item xs={12} md={4}>
                <CustomMaskedInput
                  fullWidth
                  label='Valor da comissão'
                  disableUnderline
                  InputLabelProps={{ shrink: true }}
                  mask='money'
                  startAdornment='R$'
                  value={product.recruit_commission_value}
                  onChange={changeTextValue('recruit_commission_value')}
                  helperText={validInput('recruit_commission_value') ? errorFor('recruit_commission_value') : ''}
                  error={validInput('recruit_commission_value')}
                />
              </Grid>
            )}

            <Grid item xs={12} md={4}>
              <CustomMaskedInput
                fullWidth
                disableUnderline
                InputLabelProps={{ shrink: true }}
                helperText='Limite de vendas que gerará comissão.'
                label='Máximo de vendas'
                mask='number'
                value={product.recruit_max_sales}
                onChange={changeTextValue('recruit_max_sales')}
              />
            </Grid>
          </Grid>
        </>
      )}

      {isSubscription && product.membership_fee && product.membership_comission_type === EComissionType.VALUE && (
        <Grid item xs={12} md={4}>
          <CustomMaskedInput
            fullWidth
            label='Valor da comissão de adesão'
            helperText={validInput('membership_comission_value') ? errorFor('membership_comission_value') : ''}
            error={validInput('membership_comission_value')}
            disableUnderline
            InputLabelProps={{ shrink: true }}
            mask='money'
            startAdornment='R$'
            value={product.membership_comission_value}
            onChange={changeTextValue('membership_comission_value')}
          />
        </Grid>
      )}
    </>
  );
};
